export default __webpack_public_path__ + "static/media/traffic_light_red.6b936fa2.png";